<template>
  <div align="center">
    <span :style="style">
      <i :class="icon"></i>
    </span>
  </div>
</template>

<script type="text/javascript">
import Vue from "vue";
export default Vue.extend({
  computed: {
    style: {
      // getter
      get: function() {
        if (this.params.color) {
          return "color:" + this.params.color + ";";
        } else return "";
      },
      // setter
      set: function(newValue) {
        this.params.value = newValue;
      }
    },
    icon: {
      // getter
      get: function() {
        if (this.params.icon) {
          return this.params.icon;
        } else return null;
      },
      // setter
      set: function(newValue) {
        this.params.value = newValue;
      }
    }
  },
  data() {
    return {};
  },
  methods: {}
});
</script>
